import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("AXIORA ErrorBoundary:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div data-testid="error-boundary" className="min-h-screen flex items-center justify-center bg-[#050505] px-6">
          <div className="max-w-md text-center">
            <h1 className="font-serif-ax text-4xl ax-gold-text mb-4">AXIORA</h1>
            <p className="text-[#F5F5F7] text-lg mb-2">Ocurrió un problema al mostrar esta sección</p>
            <p className="text-[#71717A] text-sm mb-6">Intenta recargar. Si persiste, cierra sesión y vuelve a entrar.</p>
            <button
              data-testid="error-reload-btn"
              onClick={() => window.location.reload()}
              className="px-5 h-11 rounded-lg bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#0A0A0A] font-semibold hover:opacity-90"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
